import dayjs from 'dayjs';
import React, { useRef } from 'react';
import { factory } from '../../../factory/factory.utils.mjs';
import { LevelsGroup } from '../LevelsGroup/LevelsGroup.mjs';
import { MonthLevel } from '../MonthLevel/MonthLevel.mjs';
import { handleControlKeyDown } from './MonthLevelGroup.utils.mjs';

const MonthLevelGroup = factory((props, ref) => {
  const {
    month,
    locale,
    firstDayOfWeek,
    weekdayFormat,
    weekendDays,
    getDayProps,
    excludeDate,
    minDate,
    maxDate,
    renderDay,
    hideOutsideDates,
    focusOutsideMonthDays,
    hideWeekdays,
    getDayAriaLabel,
    __onDayClick,
    __onDayMouseEnter,
    __preventFocus,
    onNext,
    onPrevious,
    onLevelClick,
    nextLabel,
    previousLabel,
    nextDisabled,
    previousDisabled,
    hasNextLevel,
    numberOfColumns = 1,
    levelControlAriaLabel,
    monthLabelFormat,
    __stopPropagation,
    isStatic,
    ...rest
  } = props;
  const daysRefs = useRef([]);
  const months = Array(numberOfColumns).fill(0).map((_, monthIndex) => {
    const currentMonth = dayjs(month).add(monthIndex, "months").toDate();
    return /* @__PURE__ */ React.createElement(
      MonthLevel,
      {
        key: monthIndex,
        month: currentMonth,
        withNext: monthIndex === numberOfColumns - 1,
        withPrevious: monthIndex === 0,
        monthLabelFormat,
        __stopPropagation,
        __onDayClick,
        __onDayMouseEnter,
        __onDayKeyDown: (event, payload) => handleControlKeyDown({
          levelIndex: monthIndex,
          rowIndex: payload.rowIndex,
          cellIndex: payload.cellIndex,
          event,
          controlsRef: daysRefs
        }),
        __getDayRef: (rowIndex, cellIndex, node) => {
          if (!Array.isArray(daysRefs.current[monthIndex])) {
            daysRefs.current[monthIndex] = [];
          }
          if (!Array.isArray(daysRefs.current[monthIndex][rowIndex])) {
            daysRefs.current[monthIndex][rowIndex] = [];
          }
          daysRefs.current[monthIndex][rowIndex][cellIndex] = node;
        },
        levelControlAriaLabel: typeof levelControlAriaLabel === "function" ? levelControlAriaLabel(currentMonth) : levelControlAriaLabel,
        locale,
        firstDayOfWeek,
        weekdayFormat,
        weekendDays,
        getDayProps,
        excludeDate,
        minDate,
        maxDate,
        renderDay,
        hideOutsideDates,
        hideWeekdays,
        focusOutsideMonthDays,
        getDayAriaLabel,
        __preventFocus,
        onNext,
        onPrevious,
        onLevelClick,
        nextDisabled,
        previousDisabled,
        hasNextLevel,
        nextLabel: nextLabel || "Next month",
        previousLabel: previousLabel || "Previous month",
        isStatic
      }
    );
  });
  return /* @__PURE__ */ React.createElement(LevelsGroup, { ref, ...rest }, months);
});

export { MonthLevelGroup };
